export default __webpack_public_path__ + "static/media/3_P22F8N.b548c3cf.jpg";